import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import api from '../../../utils/api';

import OverviewTab from './tabs/OverviewTab';
import LiveAttendanceTracker from '../../../components/portal/LiveAttendanceTracker';

// Map old in-page tab names → new sidebar routes so the OverviewTab's
// stat cards still navigate when clicked.
const TAB_TO_ROUTE = {
  'Daily Updates': '/portal/employee/updates',
  'Leave Request': '/portal/employee/leave',
  'My Tasks':      '/portal/employee/tasks',
  'Personal TODO': '/portal/employee/todos',
  'Attendance':    '/portal/employee/attendance',
};

export default function EmployeeDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [profile,        setProfile]        = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);

  useEffect(() => {
    const id = user?.id || user?._id || user?.userId;
    if (!id) { setLoadingProfile(false); return; }
    api.get(`/users/${id}`)
      .then((res) => setProfile(res.data?.user || res.data?.data || res.data))
      .catch(() => setProfile(user))
      .finally(() => setLoadingProfile(false));
  }, [user]);

  const hour     = new Date().getHours();
  const greeting = hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';

  const handleNavigate = (tab) => {
    const path = TAB_TO_ROUTE[tab];
    if (path) navigate(path);
  };

  return (
    <div className="p-7 space-y-6 bg-[#F8FAFC]">
      {/* Header */}
      <div>
        <p className="label-meta mb-1">{greeting}</p>
        <h1 className="heading-md text-[#1F2937]">
          {profile?.name || user?.name || 'Employee'}'s Dashboard
        </h1>
        <p className="text-[#6B7280] text-sm mt-1">
          {new Date().toLocaleDateString('en-IN', {
            weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
          })}
        </p>
      </div>

      {/* Live attendance tracker — start/stop tasks directly from the dashboard */}
      <LiveAttendanceTracker />

      {/* Overview content */}
      <OverviewTab
        profile={profile}
        loading={loadingProfile}
        onTabSwitch={handleNavigate}
      />
    </div>
  );
}
